module.exports = __webpack_public_path__ + "static/media/tip_dog_tick_fr.37402cba.png";